import { motion } from "framer-motion";
// import {
//   ChatBubbleLeftRightIcon,
//   CodeBracketIcon,
//   PaperAirplaneIcon,
//   UserGroupIcon,
// } from "@heroicons/react/24/outline";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { name: "About", href: "#" },
    // { name: "Privacy Policy", href: "#" },
    // { name: "Licensing", href: "#" },
    { name: "Contact", href: "https://x.com/yourdevkalki" },
  ];

  return (
    <footer className=" bg-black rounded-lg shadow-sm  m-2 relative z-0">
      <div className="w-full max-w-screen-2xl mx-auto p-4 md:py-8  bg-black">
        <div className="sm:flex sm:items-center sm:justify-between">
          <motion.a
            href="/"
            className="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
              InsightSwarm
            </span>
          </motion.a>
          <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
            {footerLinks.map((link) => (
              <li key={link.name}>
                <motion.a
                  href={link.href}
                  className="hover:underline me-4 md:me-6"
                  whileHover={{ x: 5 }}
                >
                  {link.name}
                </motion.a>
              </li>
            ))}
          </ul>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <span className="block text-sm text-gray-500 sm:text-center dark:text-gray-400">
          © {currentYear}{" "}
          <motion.a
            href="/"
            className="hover:underline"
            whileHover={{ scale: 1.05 }}
          >
            InsightSwarm™
          </motion.a>
          . All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
